import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-common-circle-loader',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './common-circle-loader.component.html',
  styleUrl: './common-circle-loader.component.scss'
})
export class CommonCircleLoaderComponent {
  /** Optional message below the spinner */
  @Input() message: string = 'Loading...';
  /** Spinner diameter in pixels */
  @Input() diameter: number = 48;
}
